import { render, staticRenderFns } from "./RegionSetupSummary.vue?vue&type=template&id=62f38c48&scoped=true"
import script from "./RegionSetupSummary.vue?vue&type=script&lang=js"
export * from "./RegionSetupSummary.vue?vue&type=script&lang=js"
import style0 from "./RegionSetupSummary.vue?vue&type=style&index=0&id=62f38c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f38c48",
  null
  
)

export default component.exports